<template>
    <b-col col lg="4" md="6" sm="12" class="page-element">
        <h1 class="text-center">Nowe hasło</h1>
		<alert-loading v-if="loading"></alert-loading>
		<div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>
		<div v-if="!loading">
			<div class="login__field">
				<label for="_data" class="control-label">Hasło</label>
				<input v-model="password1" type="password" class="form-control" />
				<span></span>
			</div>
			<div class="login__field">
				<label for="_data" class="control-label">Powtórz hasło</label>
				<input v-model="password2" type="password" class="form-control" />
				<span></span>
			</div>
			<div class="login__field">
				<my-button text="Zatwierdź hasło" icon="tick" :action="submit" />
			</div>
		</div>
    </b-col>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import security from './../../utils/security'
    export default {
        data() {
            return {
                password1: '',
                password2: ''
            }
        },
        methods: {
            submit: function() {
                const plainPassword = this.plainPassword();

                if (plainPassword) {
                    this.$store.dispatch('security/newPassword/sendPassword', {identifier: this.$route.params.identifier, password: plainPassword})
					  .then((result) => {
						  if(result){
							security.redirectToDefaultOrLastRoute();
						  }
					  });
                }
                else {
                    this.$store.commit('security/newPassword/NEW_PASSWORD_ERROR', "Hasła nie są takie same");
                }
            },
            plainPassword() {
                if(this.password1 && this.password2 && this.password1 == this.password2) {
                    return this.password1;
                }
            }
        },
        computed: mapGetters({
            loading: 'security/newPassword/loading',
            error: 'security/newPassword/error'
        })        
    }
</script>


// WEBPACK FOOTER //
// newPassword.vue?4c069a04